import React, { useContext, useEffect, useRef, useState, useCallback, useMemo } from 'react'
import { Box, ModalClose } from '@mui/joy';
import { DataGridPro, gridFilteredDescendantCountLookupSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro'
import ListToolbar from './ListToolbar'
import { useDataProvider } from '../../../mtska-frontend-data-provider'
import { Text } from '../Typography'
import { Button } from '../Button'
import { useTranslation } from 'react-i18next'
import { BreadCrumb, useDrawer } from '../Drawer'
import { getCustomLocaleText, handleApplyRecipe, getColumnDefinition, getColumnRender } from './list.functions'
import { CustomFooter } from './customFooter/CustomFooter';
import { AppContext, useSettingContextInComponent, useSettingsContext } from 'src/mtska-frontend-app-scaffolding'
import { useCellModes, useFullScreen, useRows } from './list.hooks'
import { List as MuiList, ListItem, ListItemIcon, ListItemText, Popover, ToggleButton, ToggleButtonGroup } from '@mui/material';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import { Icon, IconButton } from 'src/mtska-frontend-app-component/assets';
import ColumnsPanel from './ColumnsPanel';
import FiltersPanel from './FiltersPanel';
import { useFormatter } from 'src/mtska-frontend-app-component/utils';
import { useWhyDidYouUpdate } from 'src/mtska-frontend-app-component/utils/WhyDidYouUpdate';

const listId = Math.random().toString(16).slice(2);
const EMPTY_FILTER_MODEL = { items: [] };

const pageSizeOptions = [5, 10, 15, 20, 100, 250, 500];

const List = (props) => {
    const {
        removeSaveButton = false,
        title,
        apiRef,
        uid,
        handleClose,
        dataProviderName,

        isDrawer, // se è drawer non deve salvare cambi di filtro, sort, ordine colonne, pin in settings
        isEmbedded, // se è embedded non deve salvare cambi di filtro, sort, ordine colonne, pin in settings

        enableSelection,
        disableMultipleRowSelection,
        rowSelectionExternalListener,
        maxRowSelection,
        selected, // array di id selezionati
        defaultSelectedValues, // array di oggetti selezionati con chiave id disponibile
        selectionModel,
        onRowSelectionModelChange = () => { },


        leftButtons = [],
        rightButtons = [],
        className = "",
        detailStack,
        onFilterPageSortChange: onGetFreshData = () => { },
        items,
        total,
        totalLabel,
        loading,
        onRowDoubleClick = () => { },
        doAction = () => { },
        doMassiveAction,
        headerFilters = true,
        mainButtonLabel = 'Save',
        intent,
        relation,
        treeData = false,
        treeDataDrawerRoutes,
        customHeader = false,
        disableColumnSort = false,
        disableColumnFilter = false,
        disableColumnMenu = false,
        hideTableFooter = false,
        hideTableToolbar = false,
        columnsNeeded, // array di colonne da visualizzare in override di settings e tableconfig
        extraColumns,
        pinnedColumns,

        // se non drawer o embedded, defaultFilters si aggiunge ai filtri dai settings,
        // se drawer o embedded, defaultFilters contiene gli unici filtri applicabili
        filters: defaultFilters = EMPTY_FILTER_MODEL,
    } = props


    // -------------
    // INIZIO ROBA BUONA
    // -------------
    const elementId = 'dataGridProContainerId'
    const { t } = useTranslation()
    const { item: config } = useDataProvider('configs/config');
    const { appConfiguration, innerHeight } = useContext(AppContext);

    const { settings, settingsLoaded, setSettingsKey, replaceFilters, comparableFilters, addKeyToFilterModel } = useSettingsContext(dataProviderName);

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localFilterModel, setLocalFilterModel] = useState();
    const [localPaginationModel, setLocalPaginationModel] = useState();
    const [localSortModel, setLocalSortModel] = useState();
    const [localRowSelectionModel, setLocalRowSelectionModel] = useState();
    const previousLocalFilterModelRef = useRef();
    const previousLocalPaginationModelRef = useRef();
    const previousLocalSortModelRef = useRef();
    const previousLocalRowSelectionModelRef = useRef();
    const previousQuickFilterValueRef = useRef();

    const { rowHeight } = appConfiguration || {};
    const { cellModesModel, handleCellClick, handleCellModesModelChange } = useCellModes();
    const { processRowUpdate, rows } = useRows({ config, dataProviderName, doAction, items });

    const [orderedColumns, setOrderedColumns] = useState([]);
    const [viewedItems, setViewedItems] = useState([]);
    const [isManaged, setIsManaged] = useState(isDrawer || isEmbedded);
    const [isInitialized, setIsInitialized] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [expansionModel, setExpansionModel] = useState({});
    const [expansionPickModel, setExpansionPickModel] = useState({});


    // -------------
    // GESTIONE DELLA RICEZIONE STATI IN PARTENZA
    // -------------
    useEffect(() => {
        if (!settings || !settingsLoaded) return;

        const columns = getColumnRender(settings, config, dataProviderName, localFilterModel, t, detailStack, processRowUpdate);

        const orderedColumns = (columnsNeeded || settings.columnOrder || []).map((colId) =>
            columns.find((column) => column.field === colId)
        ).filter(Boolean);
        const normalizedExtraColumns = (Array.isArray(extraColumns) ? extraColumns : []).filter((column) => column?.field);
        const finalOrderedColumns = [...orderedColumns, ...normalizedExtraColumns];

        if (isManaged && !localPaginationModel) {
            setLocalPaginationModel({ "page": 0, "pageSize": 10 })
        } else if (!isManaged) {
            setLocalPaginationModel(settings.paginationModel)
        }

        setOrderedColumns(finalOrderedColumns);
    }, [settings, settingsLoaded, columnsNeeded, extraColumns, localFilterModel]);

    useEffect(() => {
        if (!filterModel) return;
        setLocalFilterModel(addKeyToFilterModel(filterModel));
    }, [filterModel]);

    useEffect(() => {
        if (!enableSelection) {
            return;
        }

        if (Array.isArray(selectionModel)) {
            //console.info('Invoco setLocalRowSelectionModel 1')
            setLocalRowSelectionModel(selectionModel);
            return;
        }

        if (Array.isArray(selected)) {
            //console.info('Invoco setLocalRowSelectionModel 1')
            setLocalRowSelectionModel(selected);
            return;
        }

        if (Array.isArray(defaultSelectedValues)) {
            const tmp = defaultSelectedValues.reduce((a, v) => ({ ...a, [v.id]: v }), {});
            setViewedItems(tmp);

            const selectedItemsIds = defaultSelectedValues.map(el => el._id);
            //console.info('Invoco setLocalRowSelectionModel 2')
            setLocalRowSelectionModel(selectedItemsIds);
            return;
        }

        //console.info('Invoco setLocalRowSelectionModel 3')
        setLocalRowSelectionModel([]);

    }, [selected, defaultSelectedValues, selectionModel, enableSelection]);

    // -------------
    // GESTIONE DEL CAMBIO DI STATO
    // -------------
    useEffect(() => {
        if (JSON.stringify(previousLocalFilterModelRef.current) !== JSON.stringify(localFilterModel)) {
            previousLocalFilterModelRef.current = localFilterModel;

            if (!isManaged && isInitialized) {
                // se siamo in una lista di base, qualsiasi modifica deve essere salvata in preferenze utente
                replaceFilters(localFilterModel);
            }

            if (localPaginationModel.page > 0) {
                // resetto la paginazione a zero, i dati verranno richiesti dallo useEffect[localPaginationModel]
                const newPaginationModel = { ...localPaginationModel, page: 0 };
                setLocalPaginationModel(newPaginationModel);
            } else {
                const filterPageSort = { ...settings, sortModel: localSortModel, filterModel: localFilterModel, paginationModel: localPaginationModel }
                onGetFreshData(filterPageSort);
                setExpansionModel({}); // se ricarico i dati, svuoto l'expansionModel
                setExpansionPickModel({}); // se ricarico i dati, svuoto l'expansionPickModel
            }
        }

        if (!isInitialized && localFilterModel) {
            setIsInitialized(true);
        }
    }, [localFilterModel]);

    useEffect(() => {
        if (JSON.stringify(previousLocalPaginationModelRef.current) !== JSON.stringify(localPaginationModel)) {
            previousLocalPaginationModelRef.current = localPaginationModel;

            if (!isManaged && isInitialized) {
                setSettingsKey('paginationModel', localPaginationModel);
            };

            const filterPageSort = { ...settings, sortModel: localSortModel, filterModel: localFilterModel, paginationModel: localPaginationModel }
            onGetFreshData(filterPageSort);
            setExpansionModel({}); // se ricarico i dati, svuoto l'expansionModel
            setExpansionPickModel({}); // se ricarico i dati, svuoto l'expansionPickModel
        }
    }, [localPaginationModel]);

    useEffect(() => {
        if (JSON.stringify(previousLocalSortModelRef.current) !== JSON.stringify(localSortModel)) {
            previousLocalSortModelRef.current = localSortModel;

            if (!isManaged && isInitialized) {
                setSettingsKey('sortModel', localSortModel);
            };

            const filterPageSort = { ...settings, sortModel: localSortModel, filterModel: localFilterModel, paginationModel: localPaginationModel }
            onGetFreshData(filterPageSort);
            setExpansionModel({}); // se ricarico i dati, svuoto l'expansionModel
            setExpansionPickModel({}); // se ricarico i dati, svuoto l'expansionPickModel
        }
    }, [localSortModel]);

    useEffect(() => {
        if (JSON.stringify(previousLocalRowSelectionModelRef.current) !== JSON.stringify(localRowSelectionModel)) {
            //console.info('localRowSelectionModel è cambiato', localRowSelectionModel,selected, selectionModel)
            previousLocalRowSelectionModelRef.current = localRowSelectionModel;

            rowSelectionExternalListener && rowSelectionExternalListener(localRowSelectionModel)
            onRowSelectionModelChange && onRowSelectionModelChange(localRowSelectionModel)
        }
    }, [localRowSelectionModel]);

    const toggleExpansionChange = useCallback((id) => {
        setExpansionModel(prev => ({
            ...prev,
            [id]: !prev[id] // Se non esiste sarà undefined, quindi !undefined = true
        }));
    }, []);

    useEffect(() => {
        if (!treeData) return;

        // castello brutto per forzare l'espansione delle righe mantenendo l'altezza del MuiDataGrid-virtualScrollerRenderZone
        // In pratica, se ho 3 righe padre con 3 figli e apro tutto, ottengo 6 righe. Aprendo il drawer il rendering ne mostra solo 3 
        // ( primo padre, primo figlio, secondo padre.)

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                // espandiamo le righe definite in expansionModel
                Object.entries(expansionModel).forEach(([id, isExpanded]) => {
                    try {
                        apiRef.current.setRowChildrenExpansion(id, isExpanded);
                    } catch (e) { }
                });
            });
            apiRef.current?.forceUpdate?.();
        });
    }, [expansionModel, isFullScreen, rowSelectionExternalListener, onRowSelectionModelChange]);

    const handleExpansionPickChange = useCallback((id) => {
        setExpansionPickModel({ 'row_id': id });
        //console.info('handleExpansionPickChange', { 'row_id': id })
    }, []);

    const slots = {
        footer: !hideTableFooter && CustomFooter,
        toolbar: !hideTableToolbar && ListToolbar,
        columnsPanel: ColumnsPanel,
        filterPanel: FiltersPanel
    }

    // Some API clients return undefined while loading
    // Following lines are here to prevent `rowCount` from being undefined during the loading
    const rowCountRef = useRef(total || 0);

    const rowCount = useMemo(() => {
        if (total !== undefined) {
            rowCountRef.current = total;
        }
        return rowCountRef.current;
    }, [total]);

    const lastRowOpened = useRef();
    const lastRowOpenMethod = useRef();
    const handleRowOpen = (row, method) => {
        if (lastRowOpened.current?.id == row.id && method == 'keyboard') {
            return;
        }
        onRowDoubleClick(row);

        lastRowOpened.current = row;
        lastRowOpenMethod.current = method;
    }
    // -------------
    // FINE ROBA BUONA
    // -------------

    // *******************************************************************
    // MANAGE ROW SELECTION & ASSOCIATION
    // *******************************************************************


    const localHandleSubmit = () => {
        if (!localRowSelectionModel && !selected) return;

        if (intent === 'relationshipManagement' && relation && Array.isArray(localRowSelectionModel) && localRowSelectionModel.length > 0) {

            // console.info('localHandleSubmit', relation);

            // creo la relazione tra papà e figli selezionati
            relation.doAction && relation.doAction({
                action: 'relationshipAssociation',
                model: relation.dataProviderName,
                data: {
                    relationName: relation.name,
                    parentId: relation.parentItemID,
                    childrenId: localRowSelectionModel,
                }
            }).then(() => {
                // console.info('relationshipAssociation completed')
                handleClose(uid, localRowSelectionModel)
            });
        } else {
            // questa non so cosa faccia
            const selectedItems = localRowSelectionModel ? localRowSelectionModel.map(id => viewedItems[id]).filter(item => item) : selected
            const callback = () => handleClose(uid, selectedItems)
            doMassiveAction ? doMassiveAction({ callback, selectedItems }) : callback()
        }
    }


    // forza display: 'none' a Checkbox selection 
    useEffect(() => {
        const observer = new MutationObserver(() => {
            document.querySelectorAll('.MuiFormControlLabel-root').forEach((el) => {
                if (el.textContent?.includes('Checkbox selection')) {
                    el.style.display = 'none'
                }
            })
        })
        observer.observe(document.body, { childList: true, subtree: true })
        return () => observer.disconnect()
    }, []);


    return !config?.data?.modules[dataProviderName]?.tableConfig ? (<>
        No tableConfig received for module '{dataProviderName}'!<br />
        Check server side config_modules configuration!
    </>) : (<>
        {isDrawer && (
            <>
                <Box className="drawer-section-header" >
                    <ModalClose />
                    <Text level="title-md" icon >{title}</Text>
                    {!removeSaveButton && (<Button label={t(mainButtonLabel)} className="button-main" onClick={localHandleSubmit} />)}
                </Box>
                <BreadCrumb />
            </>
        )}

        {drawable && (
            <Box
                className={isEmbedded ? className + " form-element" : "drawer-section-content"}
                id={elementId}
            >
                <Box className={(className + " list-system listy-system-" + listId + (isFullScreen ? " list-system-fullscreen" : "")).trim()}>

                    {/* 
                    <JSONPretty data={selected} className='json-wrapper' />
                    <JSONPretty data={selectionModel} className='json-wrapper' />
                    <JSONPretty data={localRowSelectionModel} className='json-wrapper' />
                    <JSONPretty data={columnsNeeded} className='json-wrapper' />
                    <JSONPretty data={config?.data?.modules[dataProviderName]?.tableConfig} className='json-wrapper' />
                    <JSONPretty data={orderedColumns} className='json-wrapper' />
                    <JSONPretty data={filterModel} className='json-wrapper' /> 
                    <JSONPretty data={localFilterModel} className='json-wrapper' /> 
                    <JSONPretty data={localPaginationModel} className='json-wrapper' />
                    */}
                    <DataGridPro
                        cellModesModel={cellModesModel}
                        onCellClick={handleCellClick}
                        onCellModesModelChange={handleCellModesModelChange}
                        processRowUpdate={processRowUpdate}
                        rows={rows || []}

                        apiRef={apiRef}
                        columns={orderedColumns}

                        filterModel={localFilterModel}
                        columnVisibilityModel={settings?.visibilityModel}
                        paginationModel={localPaginationModel}
                        rowSelectionModel={localRowSelectionModel}
                        pinnedColumns={pinnedColumns}

                        onColumnVisibilityModelChange={(visibilityModel) => {
                            if (isManaged) return;
                            //console.info('>>>> ListComponent:onColumnVisibilityModelChange chiamo setSettingsKey', visibilityModel, Date.now())
                            setSettingsKey('visibilityModel', { ...visibilityModel, __check__: true })
                        }}
                        onColumnOrderChange={(columnSwapInstructions) => {
                            if (isManaged) return;
                            const { oldIndex, targetIndex } = columnSwapInstructions;
                            const newColumnOrder = [...settings.columnOrder];
                            //console.info('COL ORDER IN PARTENZA', [...newColumnOrder])
                            if (oldIndex >= 0 && oldIndex < newColumnOrder.length &&
                                targetIndex >= 0 && targetIndex < newColumnOrder.length) {
                                const draggedField = columnSwapInstructions?.column?.field;
                                const sourceIndex = draggedField ? newColumnOrder.indexOf(draggedField) : (oldIndex - 2);
                                const destinationIndex = Math.max(0, Math.min(newColumnOrder.length - 1, targetIndex - 2));
                                const element = sourceIndex >= 0 ? newColumnOrder.splice(sourceIndex, 1)[0] : undefined;
                                if (element !== undefined) {
                                    newColumnOrder.splice(destinationIndex, 0, element);
                                }
                                //console.info('COL ORDER IN ARRIVO', [...newColumnOrder])
                                // console.info('>>>> ListComponent:onColumnOrderChange chiamo setSettingsKey', newColumnOrder, Date.now())
                                setSettingsKey('columnOrder', newColumnOrder);
                            }
                        }}
                        onFilterModelChange={(newFilterModel, details) => {
                            // accettiamo solo input utente, non fasi di inizializzazione
                            const quickFilterValue = newFilterModel?.quickFilterValues?.[0] ?? null;
                            if (!['deleteFilterItem', 'upsertFilterItem'].includes(details.reason) && quickFilterValue == previousQuickFilterValueRef.current) return;

                            previousQuickFilterValueRef.current = quickFilterValue;

                            // Debounce per digitazione utente
                            clearTimeout(window.filterDebounceTimer);

                            window.filterDebounceTimer = setTimeout(() => {
                                const _filtersNow = comparableFilters(localFilterModel);
                                const _filtersIncoming = comparableFilters(newFilterModel);

                                if (JSON.stringify(_filtersNow) != JSON.stringify(_filtersIncoming)) {
                                    //console.info('>>>> ListComponent:onFilterModelChange chiamo handleLocalFilterModelChange con argomento', newFilterModel, 'filtri veri', localFilterModel, 'details', details, Date.now())
                                    setLocalFilterModel(addKeyToFilterModel(newFilterModel));
                                }
                            }, 1000);
                        }}
                        onPinnedColumnsChange={(pinnedColumns) => {
                            if (isManaged) return;
                            //console.info('>>>> ListComponent:onPinnedColumnsChange chiamo setSettingsKey con argomento ', pinnedColumns, Date.now())
                            setSettingsKey('pinnedColumns', pinnedColumns);
                        }}
                        onSortModelChange={(sortModel) => {
                            setLocalSortModel(sortModel);
                        }}
                        onRowSelectionModelChange={(newRowSelectionModel) => {
                            const selectionModel = maxRowSelection ? newRowSelectionModel.slice(-maxRowSelection) : newRowSelectionModel
                            setLocalRowSelectionModel(selectionModel)
                        }}

                        slots={slots}
                        slotProps={{
                            toolbar: {
                                leftButtons,
                                rightButtons,
                                isFullScreen,
                                setIsFullScreen,
                                dataProviderName,
                                handleApplyRecipe,
                                total: customHeader ? total : undefined,
                                totalLabel,
                                apiRef,
                                setSettingsKey,
                                isManaged
                            },
                            footer: {
                                onPaginationModelChange: (paginationModel) => {
                                    setLocalPaginationModel(paginationModel);
                                },
                                pageSizeOptions,
                                paginationModel: localPaginationModel,
                                rowCount
                            },
                            filterPanel: {
                                dataProviderName,
                                columns: getColumnDefinition(settings, config, dataProviderName, t)
                            },
                            columnsPanel: {
                                dataProviderName,
                                columns: getColumnDefinition(settings, config, dataProviderName, t)
                            },
                            columnHeaderFilterIconButton: {
                                className: 'tua-classe-filtro-personalizzata'
                            },
                            baseButton: {
                                className: 'tuo-bottone-filtro'
                            }
                        }}

                        treeData={treeData}
                        getTreeDataPath={(row) => row.hierarchy}
                        groupingColDef={{
                            headerName: 'Similar',
                            minWidth: 210,
                            width: 210,
                            maxWidth: 220,
                            renderCell: (params) => <CustomGridTreeDataGroupingCell {...params} treeDataDrawerRoutes={treeDataDrawerRoutes} onExpansionModelChange={toggleExpansionChange} onExpansionPickModelChange={handleExpansionPickChange} />,
                            disableColumnMenu: false,
                            pinnable: true, 
                            //renderHeaderFilter: (params) => getCustomFilterOperators({ options:[], t, type:'select', value:'..' }),
                        }}

                        disableRowSelectionOnClick
                        disableColumnMenu={disableColumnMenu}
                        disableColumnSort={disableColumnSort}
                        disableColumnSorting={disableColumnSort}
                        disableColumnFilter={disableColumnFilter}
                        disableMultipleRowSelection={disableMultipleRowSelection}

                        checkboxSelection={enableSelection}

                        getRowId={(row) => row._id}
                        pagination
                        paginationMode="server"
                        rowsPerPage={10}
                        loading={loading}

                        hideFooter={hideTableFooter}
                        filterMode="server"
                        sortingMode="server"
                        keepNonExistentRowsSelected
                        onRowClick={(params) => {
                            // Single click in mobile, double click in desktop
                            if (window.innerWidth < 768) {
                                handleRowOpen({ id: params.id }, 'pointer');
                                return;
                            }

                            // Desktop: se è nodo padre in treeData, toggle espansione figli
                            if (treeData && window.event?.shiftKey) {
                                const rowNode = apiRef.current?.getRowNode(params.id);
                                if (rowNode?.type === 'group') {
                                    toggleExpansionChange(params.id);
                                    return;
                                }
                            }
                        }}
                        
                        onRowDoubleClick={(params) => {
                            // Desktop only
                            if (window.innerWidth >= 768) {
                                handleRowOpen({ id: params.id }, 'pointer');
                            }
                        }}
                        onCellKeyDown={(params, event) => {
                            if (event.key === 'Enter') {
                                handleRowOpen({ id: params.id }, 'keyboard');
                            }
                        }}
                        className={"list-wrapper list-wrapper-" + listId}
                        headerFilters={headerFilters}
                        localeText={getCustomLocaleText({ t })}

                        //autoHeight={true}
                        sx={isFullScreen && !isManaged
                            ? {
                                '& .MuiDataGrid-virtualScroller': {
                                    overflow: 'auto'
                                }
                            } : {}
                        }
                        getRowClassName={(params) => {
                            if (params?.row?._id === expansionPickModel.row_id) {
                                return 'picked';
                            }
                            return '';
                        }}
                        isRowSelectable={(params) => {
                            return params?.row?.hierarchy === undefined || params?.row?.hierarchy.length == 1
                        }}
                    />

                </Box>
            </Box>
        )}
    </>
    )
}

export default List

const CustomGridTreeDataGroupingCell = (props) => {
    const { id, field, rowNode, onExpansionModelChange, onExpansionPickModelChange } = props;
    const apiRef = useGridApiContext();
    const filteredDescendantCountLookup = useGridSelector(
        apiRef,
        gridFilteredDescendantCountLookupSelector,
    );
    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

    const handleExpansionModel = (event) => {
        if (rowNode.type !== 'group') {
            return;
        }

        onExpansionModelChange(id);
        event.stopPropagation();
    };

    const row = apiRef.current.getRow(id);

    return (
        <>
            {filteredDescendantCount > 0 && (
                <>
                    <IconButton icon={rowNode.childrenExpanded ? "faMinus" : "faPlus"} onClick={handleExpansionModel} tabIndex={-1} size="small"></IconButton> {filteredDescendantCount} similar
                </>
            )}
            {rowNode.depth == 1 && (
                <ChildRowInfoCell id={id} field={field} rowNode={rowNode} row={row} treeDataDrawerRoutes={props.treeDataDrawerRoutes} onExpansionPickModelChange={onExpansionPickModelChange} />
            )}
        </>
    );
};

const ChildRowInfoCell = (props) => {
    const { activate } = useDrawer();
    const { formatPercentage } = useFormatter();
    const { rowNode, row } = props;
    const [anchorEl, setAnchorEl] = useState(null);

    const handleInspectChild = () => {
        const drawerRoute = props?.treeDataDrawerRoutes?.inspect ?? null
        if (!drawerRoute) {
            alert('Drawer route Inspect not defined')
            return;
        }
        activate(drawerRoute, { id: (row._id ?? '').substring(0, 24) });
        if (props.onExpansionPickModelChange) props.onExpansionPickModelChange(row._id)
    }

    const handleInspectContractChild = () => {
        const drawerRoute = props?.treeDataDrawerRoutes?.contract ?? null;
        if (!drawerRoute) {
            alert('Drawer route Contract not defined')
            return;
        }
        activate(drawerRoute, { id: (row.contract._id ?? '').substring(0, 24) });
        if (props.onExpansionPickModelChange) props.onExpansionPickModelChange(row._id)
    }

    const handlePickChildAsReference = () => {
        const parent_id = (row.hierarchy ?? [null])[0];
        const child_id = (row._id ?? '').substring(0, 24);

        console.info(parent_id, child_id)
        if (!parent_id || !child_id) {
            alert('Non trovato parentID o childID')
            return;
        }

        const drawerRoute = props?.treeDataDrawerRoutes?.choose ?? null
        if (!drawerRoute) alert('Drawer route Choose not defined')
        activate(drawerRoute, { id: parent_id, similar_id: child_id });
        if (props.onExpansionPickModelChange) props.onExpansionPickModelChange(row._id)
    }

    const handleInfo = (e) => {
        setAnchorEl(e.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const getClassNameByScore = () => {
        const score = row.analysis?.scores?.total ?? 0;
        switch (true) {
            case (score > 99):
                return "success"
            case (score > 80):
                return "good"
            case (score > 65):
                return "warning"
            default:
                return "danger"
        }
    }

    return (
        <Box className="mtska-child-row-info-wrapper">
            {
                row.analysis?.engine && (
                    <Box className={"mtska-child-row-info-summary " + getClassNameByScore()}>
                        <ChildRowEngineIndicator engine={row.analysis?.engine} />
                        <span className="mtska-child-row-info-score">{formatPercentage((row.analysis?.scores?.total ?? 0) / 100)}</span>
                        <Button icon="faInfo" size="small" onClick={handleInfo} />
                        <ChildRowInfoDetail
                            scores={row.analysis?.scores}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                        />
                    </Box>
                )
            }

            <Button icon="faCar" size="small" onClick={handleInspectChild} className={"info"} />
            <Button icon="faFile" size="small" onClick={handleInspectContractChild} className={"info"} />
            <Button icon="faMerge" size="small" onClick={handlePickChildAsReference} />
        </Box>
    );
}

const ChildRowEngineIndicator = ({ engine }) => {

    // return (
    //     <span className="mtska-child-row-info-engine">{(engine ?? '?').substring(0, 1)}</span>
    // )
    const engine_sigla = engine.substring(0, 1).toUpperCase();
    return (
        <ToggleButtonGroup
            value={engine_sigla}
            className='mtska-toggle-group'
            exclusive
            size="small"

        >
            <ToggleButton value="H" className={engine_sigla == 'H' ? "mtska-toggle-button mtska-toggle-selected" : "mtska-toggle-button"}>H</ToggleButton>
            <ToggleButton value="S" className={engine_sigla == 'S' ? "mtska-toggle-button mtska-toggle-selected" : "mtska-toggle-button"}>S</ToggleButton>
        </ToggleButtonGroup>
    );
};

const ChildRowInfoDetail = ({ scores, anchorEl, onClose }) => {
    const { t } = useTranslation();
    const { formatPercentage } = useFormatter();
    const open = Boolean(anchorEl);
    const icons = {
        datesConsistency: "faCalendar",
        renter: "faUser",
        customer: "faUsers",
        make: "faIndustry",
        model: "faCar",
        setup: "faListCheck",
        mileage: "faRoad",
        duration: "faClock",
        leasefee: "faMoneyBill",
        start_at: "faPlay",
        end_at: "faStop"
    };

    if (!scores) return null;


    const getClassNameByScore = (score) => {

        switch (true) {
            case (score > 99):
                return "success"
            // case (score > 80):
            //     return "good"
            // case (score > 65):
            //     return "warning"
            default:
                return "danger"
        }
    }

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            disableRestoreFocus
            disableAutoFocus
            disableEnforceFocus
            className="mtska-child-row-info-detail"
        >
            <Box sx={{ p: 2, minWidth: 200 }}>
                <MuiList>
                    {Object.entries(scores)
                        .filter(([key]) => key !== 'total')
                        .map(([key, score]) => (
                            <ListItem key={key} className={getClassNameByScore(score ?? 0)}>
                                <ListItemIcon>
                                    <Icon icon={icons[key]} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={t(key)}
                                    secondary={formatPercentage((score ?? 0) / 100)}
                                />
                            </ListItem>
                        ))}
                </MuiList>
            </Box>
        </Popover>
    );
};
